<!-- src/views/MembresiasList.vue -->
<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Encabezado -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-emerald-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-emerald-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          <Icon icon="mdi:account-group" class="text-emerald-600" />
          Membresías / Socios
        </h1>
        <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5">SYSTEM JJ - Control de Gimnasio</p>
      </div>

      <div class="flex gap-2 w-full sm:w-auto">
        <button @click="abrirModalCrearSocio" class="flex-1 sm:flex-none px-3 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-emerald-600 to-teal-600 text-white rounded-xl font-bold shadow-md hover:shadow-lg transition-all flex items-center justify-center gap-2 text-sm">
          <Icon icon="mdi:account-plus" class="text-lg" />
          <span class="hidden sm:inline">Nuevo Socio</span>
          <span class="sm:hidden">Nuevo</span>
        </button>
      </div>
    </div>

    <!-- ⭐ Estado del lector FS88H -->
    <div v-if="estadoLector" class="mb-3 p-2.5 bg-green-50 dark:bg-green-900/20 rounded-xl border border-green-200 dark:border-green-800 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <span class="w-2.5 h-2.5 rounded-full bg-green-500 animate-pulse"></span>
        <span class="text-xs font-bold text-green-700 dark:text-green-300">✅ Lector FS88H listo para capturar huellas</span>
      </div>
      <span class="text-[10px] text-green-600 dark:text-green-400 font-mono">USB</span>
    </div>
    <div v-else class="mb-3 p-2.5 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-200 dark:border-amber-800 flex items-center gap-2">
      <Icon icon="mdi:alert" class="text-amber-600" />
      <span class="text-xs font-bold text-amber-700 dark:text-amber-300">Lector FS88H desconectado — conéctalo desde Gestión de Huellas para capturar huellas</span>
    </div>

    <!-- Resumen -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-3 mb-3 sm:mb-5">
      <div class="bg-white dark:bg-gray-800 rounded-xl p-3 sm:p-4 shadow-sm border border-gray-200 dark:border-gray-700">
        <p class="text-[10px] font-black text-gray-400 uppercase">Total</p>
        <p class="text-xl sm:text-2xl font-black text-gray-800 dark:text-white">{{ membresias.length }}</p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-xl p-3 sm:p-4 shadow-sm border border-emerald-200 dark:border-emerald-900/40">
        <p class="text-[10px] font-black text-emerald-600 uppercase">Activas</p>
        <p class="text-xl sm:text-2xl font-black text-emerald-600">{{ totalActivas }}</p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-xl p-3 sm:p-4 shadow-sm border border-amber-200 dark:border-amber-900/40">
        <p class="text-[10px] font-black text-amber-600 uppercase">Por Vencer 7d</p>
        <p class="text-xl sm:text-2xl font-black text-amber-600">{{ totalPorVencer }}</p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-xl p-3 sm:p-4 shadow-sm border border-red-200 dark:border-red-900/40">
        <p class="text-[10px] font-black text-red-600 uppercase">Vencidas</p>
        <p class="text-xl sm:text-2xl font-black text-red-600">{{ totalVencidas }}</p>
      </div>
    </div>

    <!-- Filtros -->
    <div class="bg-white dark:bg-gray-800 rounded-xl p-3 sm:p-4 shadow-sm border border-gray-200 dark:border-gray-700 mb-3 sm:mb-5">
      <div class="flex flex-wrap gap-2 sm:gap-3 items-end">
        <div class="flex-1 min-w-[180px]">
          <label class="block text-[10px] font-black text-gray-400 uppercase mb-1">Buscar</label>
          <input v-model="filtro" type="text" placeholder="Nombre, cédula..."
            class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-emerald-500" />
        </div>
        <div class="w-full sm:w-40">
          <label class="block text-[10px] font-black text-gray-400 uppercase mb-1">Estado</label>
          <select v-model="filtroEstado" class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-sm">
            <option value="">Todos</option>
            <option value="activa">Activas</option>
            <option value="vencida">Vencidas</option>
            <option value="suspendida">Suspendidas</option>
            <option value="cancelada">Canceladas</option>
          </select>
        </div>
        <div class="w-full sm:w-52">
          <label class="block text-[10px] font-black text-gray-400 uppercase mb-1">Tipo</label>
          <select v-model="filtroTipo" class="w-full px-3 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-sm">
            <option value="">Todos</option>
            <option v-for="t in tipos" :key="t.idTipoMembresia" :value="t.idTipoMembresia">{{ t.nombre }}</option>
          </select>
        </div>
        <button @click="resetFiltros" class="px-3 py-2 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400 rounded-lg hover:bg-gray-200" title="Limpiar">
          <Icon icon="mdi:filter-off" class="text-lg" />
        </button>
        <button @click="cargar" class="px-3 py-2 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 rounded-lg hover:bg-emerald-100 flex items-center gap-2 text-sm font-bold">
          <Icon icon="mdi:refresh" :class="{'animate-spin': cargando}" />
          <span class="hidden sm:inline">Actualizar</span>
        </button>
      </div>
    </div>

    <!-- Tabla -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
      <div class="overflow-x-auto custom-scrollbar">
        <table class="w-full text-left">
          <thead>
            <tr class="bg-gray-50 dark:bg-gray-700/50 border-b border-gray-200 dark:border-gray-700">
              <th class="px-3 py-3 text-[10px] font-black text-gray-400 uppercase tracking-widest">Socio</th>
              <th class="px-3 py-3 text-[10px] font-black text-gray-400 uppercase tracking-widest hidden md:table-cell">Cédula</th>
              <th class="px-3 py-3 text-[10px] font-black text-gray-400 uppercase tracking-widest hidden sm:table-cell">Tipo</th>
              <th class="px-3 py-3 text-[10px] font-black text-gray-400 uppercase tracking-widest hidden lg:table-cell">Vence</th>
              <th class="px-3 py-3 text-[10px] font-black text-gray-400 uppercase tracking-widest text-center">Días</th>
              <th class="px-3 py-3 text-[10px] font-black text-gray-400 uppercase tracking-widest text-center">Estado</th>
              <th class="px-3 py-3 text-[10px] font-black text-gray-400 uppercase tracking-widest text-center">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            <tr v-if="cargando" v-for="i in 5" :key="'l'+i" class="animate-pulse">
              <td colspan="7" class="px-3 py-4"><div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full"></div></td>
            </tr>
            <tr v-else-if="membresiasFiltradas.length === 0">
              <td colspan="7" class="px-3 py-12 text-center">
                <Icon icon="mdi:account-off" class="text-5xl text-gray-300 mx-auto mb-4" />
                <p class="text-gray-500 font-bold">No hay socios</p>
                <p class="text-xs text-gray-400 mt-1">Crea el primero o ajusta los filtros</p>
              </td>
            </tr>
            <tr v-for="m in membresiasFiltradas" :key="m.idMembresia" class="hover:bg-gray-50 dark:hover:bg-gray-700/30 transition-colors">
              <td class="px-3 py-3">
                <div class="flex items-center gap-2">
                  <div class="w-10 h-10 rounded-full overflow-hidden bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center flex-shrink-0 border border-gray-200 dark:border-gray-700 relative group cursor-pointer shadow-sm" @click="capturarFotoDirecto(m)" title="Tomar o cambiar foto">
                    <img v-if="m.foto_socio" :src="getFotoUrl(m.foto_socio)" :alt="m.nombre_socio" class="w-full h-full object-cover" />
                    <span v-else class="text-xs font-black text-emerald-600 dark:text-emerald-400">{{ iniciales(m) }}</span>
                    <div class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                      <Icon icon="mdi:camera" class="text-white text-sm" />
                    </div>
                  </div>
                  <div class="min-w-0">
                    <div class="font-bold text-xs md:text-sm text-gray-800 dark:text-white truncate">{{ m.nombre_socio || 'Sin nombre' }}</div>
                    <div class="text-[10px] text-gray-400 truncate">{{ m.numero_membresia }}</div>
                  </div>
                </div>
              </td>
              <td class="px-3 py-3 text-xs text-gray-600 dark:text-gray-300 hidden md:table-cell">{{ m.documento_socio || '-' }}</td>
              <td class="px-3 py-3 hidden sm:table-cell">
                <span class="px-2 py-0.5 bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 rounded-full text-[10px] font-bold">
                  {{ m.nombre_tipo_membresia || '-' }}
                </span>
              </td>
              <td class="px-3 py-3 text-xs text-gray-600 dark:text-gray-300 hidden lg:table-cell">{{ formatFecha(m.fecha_fin) }}</td>
              <td class="px-3 py-3 text-center">
                <span :class="[
                  'px-2 py-0.5 rounded-full text-[10px] font-black',
                  m.dias_restantes > 7 ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' :
                  m.dias_restantes > 0 ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400' :
                  'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400'
                ]">{{ m.dias_restantes }}</span>
              </td>
              <td class="px-3 py-3 text-center">
                <span :class="[
                  'px-2 py-0.5 rounded-full text-[10px] font-black uppercase',
                  m.estado === 'activa' ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400' :
                  m.estado === 'vencida' ? 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400' :
                  'bg-gray-100 text-gray-500 dark:bg-gray-700'
                ]">{{ m.estado }}</span>
              </td>
              <td class="px-3 py-3">
                <div class="flex justify-center gap-1">
                  <button @click="capturarFotoDirecto(m)" class="p-1.5 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded-lg" title="Tomar / Cambiar foto del socio">
                    <Icon icon="mdi:camera-account" class="text-base" />
                  </button>
                  <button @click="openEditModal(m)" class="p-1.5 text-indigo-600 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 rounded-lg" title="Editar">
                    <Icon icon="mdi:pencil" class="text-base" />
                  </button>
                  <button @click="renovar(m)" class="p-1.5 text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 rounded-lg" title="Renovar">
                    <Icon icon="mdi:refresh" class="text-base" />
                  </button>
                  <button @click="sincronizarSocio(m)" class="p-1.5 text-cyan-600 hover:bg-cyan-50 dark:hover:bg-cyan-900/30 rounded-lg" title="Sincronizar con lector facial">
                    <Icon icon="mdi:face-recognition" class="text-base" />
                  </button>
                  <!-- ⭐ HUELLA: Ahora funciona para TODOS los socios (clientes) -->
                  <button
                    v-if="m.idCliente"
                    @click="capturarHuellaSocioExistente(m)"
                    class="p-1.5 text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-900/30 rounded-lg"
                    title="Capturar huella digital (FS88H)"
                  >
                    <Icon icon="mdi:fingerprint" class="text-base" />
                  </button>
                  <button @click="confirmDelete(m)" class="p-1.5 text-red-600 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg" title="Cancelar">
                    <Icon icon="mdi:trash-can" class="text-base" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- MODAL CREAR/EDITAR SOCIO -->
    <Teleport to="body">
      <div v-if="showModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 z-[9999] overflow-y-auto" @click.self="showModal = false">
        <div class="bg-white dark:bg-gray-800 w-full max-w-md md:max-w-2xl rounded-2xl shadow-2xl overflow-hidden animate-zoomIn my-auto max-h-[95vh] flex flex-col">

          <div class="bg-gradient-to-r from-emerald-600 to-teal-600 px-4 md:px-6 py-3 md:py-4 flex items-center gap-3 flex-shrink-0">
            <div class="p-1.5 md:p-2 bg-white/20 rounded-xl flex-shrink-0">
              <Icon :icon="isEditing ? 'mdi:pencil' : 'mdi:account-plus'" class="text-white text-lg md:text-xl" />
            </div>
            <h3 class="text-sm md:text-base font-bold text-white flex-1">{{ isEditing ? 'Editar Membresía' : 'Nuevo Socio' }}</h3>
            <button @click="showModal = false" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all">
              <Icon icon="mdi:close" class="text-white text-lg md:text-xl" />
            </button>
          </div>

          <div class="p-4 md:p-6 space-y-4 overflow-y-auto custom-scrollbar flex-1">

            <template v-if="!isEditing">
              <div class="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 overflow-visible relative z-20">
                <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800 px-3 py-2 border-b border-gray-100 dark:border-gray-700 rounded-t-2xl">
                  <h2 class="text-sm font-bold text-gray-800 dark:text-white flex items-center">
                    <div class="p-1.5 bg-blue-100 dark:bg-blue-900/30 rounded-lg mr-2">
                      <Icon icon="mdi:account" class="text-blue-600 dark:text-blue-400 text-base" />
                    </div>
                    Información del Socio
                    <span class="ml-2 text-[9px] bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400 px-2 py-0.5 rounded-full font-bold">* Requerido</span>
                  </h2>
                </div>
                <div class="p-3">
                  <div class="flex space-x-1 bg-gray-100 dark:bg-gray-700 p-1 rounded-xl mb-3">
                    <button @click="modoCliente = 'buscar'" :class="['flex-1 px-3 py-2 text-xs font-medium rounded-lg transition-all', modoCliente === 'buscar' ? 'bg-white dark:bg-gray-800 text-blue-600 dark:text-blue-400 shadow-sm' : 'text-gray-600 dark:text-gray-400']">
                      <Icon icon="mdi:magnify" class="inline mr-1 text-sm" /> Buscar
                    </button>
                    <button @click="modoCliente = 'crear'" :class="['flex-1 px-3 py-2 text-xs font-medium rounded-lg transition-all', modoCliente === 'crear' ? 'bg-white dark:bg-gray-800 text-green-600 dark:text-green-400 shadow-sm' : 'text-gray-600 dark:text-gray-400']">
                      <Icon icon="mdi:account-plus" class="inline mr-1 text-sm" /> Nuevo
                    </button>
                  </div>

                  <div v-if="modoCliente === 'buscar'" class="relative">
                    <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1.5">Buscar Cliente Existente</label>
                    <div class="relative">
                      <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                      <input v-model="buscarCliente" type="text" placeholder="Nombre, documento, teléfono o email..."
                        class="w-full pl-10 pr-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 text-sm"
                        @input="debounceBuscarClientes" @focus="mostrarListaClientes = true" />
                    </div>

                    <div v-if="mostrarListaClientes && clientesEncontrados.length > 0"
                      class="absolute mt-2 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl max-h-60 overflow-y-auto z-50">
                      <div v-for="c in clientesEncontrados" :key="c.idCliente" @click="seleccionarCliente(c)"
                        class="p-3 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-100 dark:border-gray-700 last:border-b-0">
                        <div class="flex items-center gap-3">
                          <div class="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                            <Icon icon="mdi:account-circle" class="text-blue-600 dark:text-blue-400 text-xl" />
                          </div>
                          <div class="flex-1 min-w-0">
                            <p class="font-semibold text-gray-800 dark:text-white text-sm">{{ c.nombre }} {{ c.apellido }}</p>
                            <p class="text-xs text-gray-500 dark:text-gray-400">{{ c.documento }}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="buscarCliente && buscarCliente.trim().length >= 2 && !cargandoClientes && clientesEncontrados.length === 0"
                      class="absolute mt-2 w-full p-4 text-center bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-700 z-50">
                      <Icon icon="mdi:account-search" class="text-3xl text-gray-400 mx-auto mb-2" />
                      <p class="text-xs text-gray-600 dark:text-gray-400 mb-2">No encontramos "{{ buscarCliente }}"</p>
                      <button @click="modoCliente = 'crear'" class="px-3 py-1.5 bg-green-600 text-white text-xs rounded-lg hover:bg-green-700">
                        <Icon icon="mdi:account-plus" class="inline mr-1" /> Crear cliente
                      </button>
                    </div>
                  </div>

                  <div v-if="modoCliente === 'crear'">
                    <div class="grid grid-cols-2 gap-2.5">
                      <div>
                        <label class="block text-[10px] font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo Doc. <span class="text-red-500">*</span></label>
                        <select v-model="nuevoCliente.tipoDocumento" class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm">
                          <option value="">Seleccionar...</option>
                          <option value="cedula">Cédula</option>
                          <option value="rif">RIF</option>
                          <option value="pasaporte">Pasaporte</option>
                        </select>
                      </div>
                      <div>
                        <label class="block text-[10px] font-medium text-gray-700 dark:text-gray-300 mb-1">N° Documento <span class="text-red-500">*</span></label>
                        <input v-model="nuevoCliente.documento" type="text" placeholder="V-12345678"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm" />
                      </div>
                      <div>
                        <label class="block text-[10px] font-medium text-gray-700 dark:text-gray-300 mb-1">Nombre <span class="text-red-500">*</span></label>
                        <input v-model="nuevoCliente.nombre" type="text" placeholder="Ej: Juan"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm" />
                      </div>
                      <div>
                        <label class="block text-[10px] font-medium text-gray-700 dark:text-gray-300 mb-1">Apellido</label>
                        <input v-model="nuevoCliente.apellido" type="text" placeholder="Ej: Rodríguez"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm" />
                      </div>
                      <div>
                        <label class="block text-[10px] font-medium text-gray-700 dark:text-gray-300 mb-1">Teléfono</label>
                        <input v-model="nuevoCliente.telefono" type="text" placeholder="0414-7470715"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm" />
                      </div>
                      <div>
                        <label class="block text-[10px] font-medium text-gray-700 dark:text-gray-300 mb-1">Email</label>
                        <input v-model="nuevoCliente.email" type="email" placeholder="ejemplo@email.com"
                          class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm" />
                      </div>
                    </div>
                    <div class="flex gap-2 mt-3">
                      <button @click="guardarNuevoCliente" :disabled="!puedeGuardarCliente || guardandoCliente"
                        :class="['flex-1 px-3 py-2 rounded-xl font-medium text-sm flex items-center justify-center gap-2',
                          puedeGuardarCliente && !guardandoCliente ? 'bg-gradient-to-r from-green-600 to-emerald-600 text-white hover:from-green-700 hover:to-emerald-700 shadow-md' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 cursor-not-allowed']">
                        <Icon v-if="guardandoCliente" icon="mdi:loading" class="animate-spin" />
                        <Icon v-else icon="mdi:account-plus" />
                        {{ guardandoCliente ? 'Guardando...' : 'Guardar y Seleccionar' }}
                      </button>
                      <button @click="modoCliente = 'buscar'" class="px-3 py-2 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl hover:bg-gray-50 text-sm">
                        Cancelar
                      </button>
                    </div>
                  </div>

                  <div v-if="clienteSeleccionado" class="mt-4 p-3 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 rounded-xl border border-green-200 dark:border-green-800/50">
                    <div class="flex items-start gap-3">
                      <div class="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg">
                        <Icon icon="mdi:account-check" class="text-green-600 dark:text-green-400 text-2xl" />
                      </div>
                      <div class="flex-1 min-w-0">
                        <p class="font-bold text-gray-800 dark:text-white">{{ clienteSeleccionado.nombre }} {{ clienteSeleccionado.apellido }}</p>
                        <p class="text-xs text-gray-600 dark:text-gray-400 mt-0.5">{{ formatearTipoDocumento(clienteSeleccionado.tipoDocumento) }}: <span class="font-mono">{{ clienteSeleccionado.documento }}</span></p>
                        <p v-if="clienteSeleccionado.telefono" class="text-xs text-gray-500 mt-1">
                          <Icon icon="mdi:phone" class="inline mr-1" />{{ clienteSeleccionado.telefono }}
                        </p>
                      </div>
                      <button @click="deseleccionarCliente" class="p-1.5 text-gray-400 hover:text-gray-600 rounded-lg">
                        <Icon icon="mdi:close" class="text-lg" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <div v-if="isEditing" class="bg-emerald-50 dark:bg-emerald-900/20 rounded-xl p-4 border border-emerald-200 dark:border-emerald-800">
              <div class="flex items-center gap-3">
                <div class="w-12 h-12 rounded-full bg-emerald-100 dark:bg-emerald-900/40 flex items-center justify-center">
                  <span class="text-lg font-black text-emerald-600 dark:text-emerald-400">{{ iniciales(form) }}</span>
                </div>
                <div>
                  <p class="font-bold text-emerald-800 dark:text-emerald-300">{{ form.nombre_socio }}</p>
                  <p class="text-xs text-emerald-600 dark:text-emerald-400">{{ form.numero_membresia }}</p>
                </div>
              </div>
            </div>

            <div class="bg-white dark:bg-gray-800 rounded-2xl border border-gray-200 dark:border-gray-700 overflow-visible">
              <div class="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 px-3 py-2 border-b border-gray-100 dark:border-gray-700 rounded-t-2xl">
                <h2 class="text-sm font-bold text-gray-800 dark:text-white flex items-center">
                  <div class="p-1.5 bg-green-100 dark:bg-green-900/30 rounded-lg mr-2">
                    <Icon icon="mdi:card-account-details-star" class="text-green-600 dark:text-green-400 text-base" />
                  </div>
                  Datos de la Membresía
                </h2>
              </div>
              <div class="p-3 space-y-3">

                <div v-if="!isEditing" class="relative">
                  <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1.5">Buscar Tipo de Membresía <span class="text-red-500">*</span></label>
                  <div class="relative">
                    <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                    <input v-model="buscarTipo" type="text" placeholder="Código o nombre del plan..."
                      class="w-full pl-10 pr-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-emerald-500 text-sm"
                      @input="debounceBuscarTipos" @focus="mostrarListaTipos = true" />
                  </div>

                  <div v-if="mostrarListaTipos && tiposEncontrados.length > 0"
                    class="absolute mt-2 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl max-h-72 overflow-y-auto z-50">
                    <div v-for="t in tiposEncontrados" :key="t.idTipoMembresia" @click="seleccionarTipo(t)"
                      :class="['p-3 hover:bg-emerald-50 dark:hover:bg-emerald-900/20 cursor-pointer border-b border-gray-100 dark:border-gray-700 last:border-b-0',
                        form.idTipoMembresia === t.idTipoMembresia ? 'bg-emerald-50 dark:bg-emerald-900/30' : '']">
                      <div class="flex items-center justify-between gap-3">
                        <div class="flex items-center gap-3 flex-1 min-w-0">
                          <div class="p-2 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg flex-shrink-0">
                            <Icon icon="mdi:card-account-details-star" class="text-emerald-600 dark:text-emerald-400 text-xl" />
                          </div>
                          <div class="flex-1 min-w-0">
                            <div class="flex items-center gap-2">
                              <span class="text-[10px] font-black text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/30 px-2 py-0.5 rounded">{{ t.codigo }}</span>
                              <p class="font-bold text-gray-800 dark:text-white text-sm truncate">{{ t.nombre }}</p>
                            </div>
                            <div class="flex items-center gap-3 mt-1 text-xs">
                              <span class="text-gray-500 dark:text-gray-400">{{ t.duracion_dias }} días</span>
                              <span class="font-black text-gray-800 dark:text-white">${{ formatUsd(t.precio_usd) }}</span>
                              <span class="font-bold text-emerald-600 dark:text-emerald-400">Bs {{ formatBs(t.precio_bs) }}</span>
                            </div>
                          </div>
                        </div>
                        <Icon v-if="form.idTipoMembresia === t.idTipoMembresia" icon="mdi:check-circle" class="text-emerald-500 text-2xl flex-shrink-0" />
                      </div>
                    </div>
                  </div>

                  <div v-if="buscarTipo && buscarTipo.trim().length >= 1 && tiposEncontrados.length === 0"
                    class="absolute mt-2 w-full p-4 text-center bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-700 z-50">
                    <Icon icon="mdi:card-search" class="text-3xl text-gray-400 mx-auto mb-2" />
                    <p class="text-xs text-gray-600 dark:text-gray-400">No hay planes con "{{ buscarTipo }}"</p>
                  </div>
                </div>

                <div v-if="tipoSeleccionado" class="p-3 rounded-xl border-2 border-emerald-500 bg-emerald-50 dark:bg-emerald-900/20">
                  <div class="flex items-start justify-between gap-2">
                    <div class="flex items-center gap-2">
                      <div class="p-2 bg-emerald-100 dark:bg-emerald-900/30 rounded-lg">
                        <Icon icon="mdi:check-decagram" class="text-emerald-600 dark:text-emerald-400 text-xl" />
                      </div>
                      <div>
                        <div class="flex items-center gap-2">
                          <span class="text-[10px] font-black text-emerald-600 dark:text-emerald-400 bg-white dark:bg-emerald-900/30 px-2 py-0.5 rounded">{{ tipoSeleccionado.codigo }}</span>
                          <p class="font-bold text-gray-800 dark:text-white text-sm">{{ tipoSeleccionado.nombre }}</p>
                        </div>
                        <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{{ tipoSeleccionado.descripcion || tipoSeleccionado.duracion_dias + ' días' }}</p>
                      </div>
                    </div>
                    <button @click="deseleccionarTipo" class="p-1 text-gray-400 hover:text-gray-600 rounded" v-if="!isEditing">
                      <Icon icon="mdi:close" class="text-lg" />
                    </button>
                  </div>
                  <div class="grid grid-cols-3 gap-2 mt-3">
                    <div class="bg-white dark:bg-gray-800 rounded-lg p-2 text-center">
                      <p class="text-[9px] font-bold text-gray-400 uppercase">USD</p>
                      <p class="text-sm font-black text-gray-800 dark:text-white">${{ formatUsd(tipoSeleccionado.precio_usd) }}</p>
                    </div>
                    <div class="bg-white dark:bg-gray-800 rounded-lg p-2 text-center">
                      <p class="text-[9px] font-bold text-emerald-500 uppercase">Bs</p>
                      <p class="text-sm font-black text-emerald-600 dark:text-emerald-400">{{ formatBs(tipoSeleccionado.precio_bs) }}</p>
                    </div>
                    <div class="bg-white dark:bg-gray-800 rounded-lg p-2 text-center">
                      <p class="text-[9px] font-bold text-gray-400 uppercase">Días</p>
                      <p class="text-sm font-black text-gray-800 dark:text-white">{{ tipoSeleccionado.duracion_dias }}</p>
                    </div>
                  </div>
                </div>

                <div class="grid grid-cols-2 gap-3">
                  <div>
                    <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Fecha inicio *</label>
                    <input v-model="form.fecha_inicio" type="date" required
                      class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm focus:ring-2 focus:ring-emerald-500" />
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Fecha fin</label>
                    <input v-model="form.fecha_fin" type="date"
                      class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm focus:ring-2 focus:ring-emerald-500" />
                  </div>
                </div>

                <div class="grid grid-cols-2 gap-3">
                  <div>
                    <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Precio USD</label>
                    <div class="relative">
                      <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-bold">$</span>
                      <input v-model.number="form.precio_usd" type="number" step="0.01" min="0"
                        class="w-full pl-7 pr-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm focus:ring-2 focus:ring-emerald-500" />
                    </div>
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center gap-1">
                      Precio Bs
                      <span v-if="tasaVenta" class="text-[9px] text-emerald-500 font-bold">auto ×{{ formatBs(tasaVenta.precio_usd_bs) }}</span>
                    </label>
                    <div class="relative">
                      <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-bold text-xs">Bs</span>
                      <input v-model.number="form.precio_bs" type="number" step="0.01" min="0"
                        class="w-full pl-10 pr-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm focus:ring-2 focus:ring-emerald-500" />
                    </div>
                  </div>
                </div>

                <!-- 📸 FOTO DEL SOCIO (Cámara / Archivo) -->
                <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800 rounded-xl p-3 border-2 border-dashed border-blue-300 dark:border-blue-700">
                  <div class="flex items-center justify-between mb-2">
                    <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 flex items-center gap-1">
                      <Icon icon="mdi:face-recognition" class="text-blue-600" />
                      Foto del Socio
                    </label>
                    <span class="text-[10px] text-gray-400 font-medium">(Cámara o Archivo)</span>
                  </div>

                  <div v-if="fotoSocio" class="flex items-center gap-3">
                    <img :src="getFotoUrl(fotoSocio) || fotoSocio" class="w-20 h-20 rounded-xl object-cover border-2 border-blue-500 shadow-md" />
                    <div class="flex-1">
                      <p class="text-xs font-bold text-green-600 flex items-center gap-1">
                        <Icon icon="mdi:check-circle" /> Foto asignada
                      </p>
                      <p class="text-[10px] text-gray-500 mt-1">Vinculada con la ficha del socio y accesos.</p>
                    </div>
                    <button @click="abrirCapturador" class="p-2 text-blue-600 hover:bg-blue-50 rounded-lg mr-1" type="button" title="Cambiar foto">
                      <Icon icon="mdi:camera-retake" class="text-lg" />
                    </button>
                    <button @click="eliminarFoto" class="p-2 text-red-500 hover:bg-red-50 rounded-lg" type="button" title="Eliminar foto">
                      <Icon icon="mdi:trash-can" class="text-lg" />
                    </button>
                  </div>

                  <button v-else @click="abrirCapturador" type="button"
                    class="w-full py-3 bg-white dark:bg-gray-700 border-2 border-dashed border-blue-400 text-blue-600 dark:text-blue-400 rounded-xl font-bold text-sm hover:bg-blue-50 transition-all flex items-center justify-center gap-2">
                    <Icon icon="mdi:camera-plus" class="text-xl" />
                    Tomar o Subir Foto del Socio
                  </button>
                </div>

                <!-- ⭐ HUELLA DIGITAL (FS88H) - Para socios del gym -->
                <div class="bg-gradient-to-r from-purple-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800 rounded-xl p-3 border-2 border-dashed border-purple-300 dark:border-purple-700">
                  <label class="block text-xs font-bold text-gray-700 dark:text-gray-300 mb-2 flex items-center gap-1">
                    <Icon icon="mdi:fingerprint" class="text-purple-600" />
                    Huella Digital (FS88H)
                    <span class="text-[10px] text-purple-500 font-bold">(obligatoria para el torniquete)</span>
                  </label>

                  <!-- Estado: huella capturada -->
                  <div v-if="huellaCapturada" class="flex items-center gap-3">
                    <div class="w-20 h-20 rounded-xl bg-gradient-to-br from-purple-500 to-indigo-500 flex items-center justify-center border-2 border-purple-500">
                      <Icon icon="mdi:fingerprint" class="text-white text-4xl" />
                    </div>
                    <div class="flex-1">
                      <p class="text-xs font-bold text-green-600 flex items-center gap-1">
                        <Icon icon="mdi:check-circle" /> Huella capturada
                      </p>
                      <p class="text-[10px] text-gray-500 mt-1">
                        El socio ya puede entrar al gym con huella.
                      </p>
                    </div>
                    <button @click="huellaCapturada = false" class="p-2 text-red-500 hover:bg-red-50 rounded-lg" type="button">
                      <Icon icon="mdi:trash-can" class="text-lg" />
                    </button>
                  </div>

                  <!-- Estado: botón para capturar -->
                  <button v-else
                    @click="capturarHuellaSocio"
                    :disabled="!(clienteSeleccionado || isEditing) || !estadoLector"
                    type="button"
                    class="w-full py-3 bg-white dark:bg-gray-700 border-2 border-dashed border-purple-400 text-purple-600 dark:text-purple-400 rounded-xl font-bold text-sm hover:bg-purple-50 transition-all flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed">
                    <Icon icon="mdi:fingerprint" class="text-xl" />
                    {{ (clienteSeleccionado || isEditing) ? 'Capturar Huella del Socio' : 'Primero selecciona al cliente' }}
                  </button>

                  <!-- Aviso si el lector no está conectado -->
                  <p v-if="!estadoLector" class="text-[10px] text-amber-600 mt-2 flex items-center gap-1">
                    <Icon icon="mdi:alert" />
                    El lector FS88H no está conectado — conéctalo desde Gestión de Huellas
                  </p>
                </div>

                <div v-if="isEditing" class="grid grid-cols-2 gap-3">
                  <div>
                    <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Estado</label>
                    <select v-model="form.estado" class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm">
                      <option value="activa">Activa</option>
                      <option value="vencida">Vencida</option>
                      <option value="suspendida">Suspendida</option>
                      <option value="cancelada">Cancelada</option>
                    </select>
                  </div>
                  <div class="flex items-center gap-2 px-2 pt-6">
                    <input v-model="form.acceso_habilitado" type="checkbox" id="chk-acceso" class="w-4 h-4 rounded text-emerald-600" />
                    <label for="chk-acceso" class="text-xs font-bold text-gray-700 dark:text-gray-300">Acceso habilitado</label>
                  </div>
                </div>

                <div>
                  <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Observaciones</label>
                  <textarea v-model="form.observaciones" rows="2"
                    class="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 text-sm focus:ring-2 focus:ring-emerald-500 resize-none"></textarea>
                </div>
              </div>
            </div>
          </div>

          <div class="px-4 md:px-6 py-3 md:py-4 border-t border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button type="button" @click="showModal = false"
              class="flex-1 py-2.5 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-xl font-bold text-sm hover:bg-gray-50">
              Cancelar
            </button>
            <button @click="guardar" :disabled="guardando || !puedeGuardar"
              :class="['flex-[2] py-2.5 rounded-xl font-bold text-sm flex items-center justify-center gap-2 shadow-md',
                puedeGuardar && !guardando ? 'bg-gradient-to-r from-emerald-600 to-teal-600 text-white hover:from-emerald-700 hover:to-teal-700' : 'bg-gray-200 dark:bg-gray-700 text-gray-500 cursor-not-allowed']">
              <Icon :icon="guardando ? 'mdi:loading' : 'mdi:content-save'" :class="{'animate-spin': guardando}" class="text-lg" />
              {{ guardando ? 'Guardando...' : (isEditing ? 'Actualizar Membresía' : 'Crear Membresía') }}
            </button>
          </div>
        </div>
      </div>

      <CapturadorFoto
        :visible="mostrarCapturador"
        @cerrar="mostrarCapturador = false"
        @foto-capturada="recibirFoto"
      />
    </Teleport>

    <!-- ⭐ MODAL DE CAPTURA DE HUELLA (4 fases) -->
    <Teleport to="body">
      <div
        v-if="capturaActiva"
        class="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[10000] px-4"
      >
        <div class="bg-white dark:bg-gray-800 rounded-2xl max-w-md w-full p-8 shadow-2xl text-center">

          <!-- Fase 1: esperando -->
          <template v-if="faseCaptura === 'esperando'">
            <div class="relative mx-auto w-28 h-28 mb-5">
              <div class="absolute inset-0 bg-purple-500/20 rounded-full animate-ping"></div>
              <div class="relative bg-purple-500 rounded-full w-28 h-28 flex items-center justify-center">
                <Icon icon="mdi:fingerprint" class="text-white text-6xl" />
              </div>
            </div>
            <!-- Tarjeta del Socio con su Foto -->
            <div v-if="socioParaHuella" class="mb-4 p-3 bg-purple-50 dark:bg-purple-900/30 rounded-xl border border-purple-200 dark:border-purple-800 flex items-center gap-3 text-left">
              <div class="relative w-14 h-14 rounded-xl overflow-hidden bg-purple-200 dark:bg-purple-900 flex-shrink-0 border-2 border-purple-400 shadow-sm flex items-center justify-center">
                <img v-if="socioParaHuella.foto_socio" :src="getFotoUrl(socioParaHuella.foto_socio) || socioParaHuella.foto_socio" class="w-full h-full object-cover" />
                <Icon v-else icon="mdi:account" class="w-8 h-8 text-purple-400" />
              </div>
              <div class="min-w-0 flex-1">
                <div class="font-bold text-sm text-gray-800 dark:text-white truncate">
                  {{ socioParaHuella.nombre_socio || (socioParaHuella.nombre ? (socioParaHuella.nombre + ' ' + (socioParaHuella.apellido || '')) : 'Socio') }}
                </div>
                <div class="text-xs text-gray-600 dark:text-gray-300">
                  Cédula: <span class="font-bold text-gray-900 dark:text-white">{{ socioParaHuella.documento_socio || socioParaHuella.documento || 'No registrada' }}</span>
                </div>
                <div class="text-[10px] text-purple-600 dark:text-purple-400 font-semibold flex items-center gap-1 mt-0.5">
                  <Icon icon="mdi:link-variant" /> Vinculando huella con socio y foto
                </div>
              </div>
            </div>

            <h3 class="text-xl font-bold text-gray-800 dark:text-white">Coloca tu dedo en el lector</h3>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Apoya el dedo con firmeza, sin moverlo</p>
          </template>

          <!-- Fase 2: procesando -->
          <template v-else-if="faseCaptura === 'procesando'">
            <div class="relative mx-auto w-28 h-28 mb-5">
              <div class="absolute inset-0 rounded-full border-4 border-amber-200 dark:border-amber-900"></div>
              <div class="absolute inset-0 rounded-full border-4 border-amber-500 border-t-transparent animate-spin"></div>
              <div class="relative w-28 h-28 flex items-center justify-center">
                <Icon icon="mdi:fingerprint" class="text-amber-500 text-6xl" />
              </div>
            </div>
            <h3 class="text-xl font-bold text-gray-800 dark:text-white">Verificando huella...</h3>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">No retires el dedo todavía</p>
          </template>

          <!-- Fase 3: éxito -->
          <template v-else-if="faseCaptura === 'exito'">
            <div class="relative mx-auto w-28 h-28 mb-5">
              <div class="absolute inset-0 bg-green-500/20 rounded-full animate-ping"></div>
              <div class="relative bg-green-500 rounded-full w-28 h-28 flex items-center justify-center">
                <Icon icon="mdi:check-bold" class="text-white text-6xl" />
              </div>
            </div>
            <h3 class="text-xl font-bold text-gray-800 dark:text-white">¡Huella registrada!</h3>
            <p class="text-sm text-green-600 dark:text-green-400 mt-1">
              {{ resultadoCaptura?.mensaje || 'Huella capturada correctamente' }}
            </p>
            <p v-if="socioParaHuella" class="text-xs text-gray-500 mt-2">
              Socio: {{ socioParaHuella.nombre_socio }}
            </p>
          </template>

          <!-- Fase 4: error -->
          <template v-else-if="faseCaptura === 'error'">
            <div class="relative mx-auto w-28 h-28 mb-5">
              <div class="relative bg-red-500 rounded-full w-28 h-28 flex items-center justify-center">
                <Icon icon="mdi:close-thick" class="text-white text-6xl" />
              </div>
            </div>
            <h3 class="text-xl font-bold text-gray-800 dark:text-white">No se pudo procesar</h3>
            <p class="text-sm text-red-500 mt-1">{{ mensajeError }}</p>
            <button
              @click="reintentarCaptura"
              class="mt-4 px-5 py-2 bg-purple-500 hover:bg-purple-600 text-white rounded-lg text-sm"
            >
              Intentar de nuevo
            </button>
          </template>

          <button
            v-if="faseCaptura !== 'procesando'"
            @click="cancelarCaptura"
            class="mt-6 text-sm text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
          >
            Cancelar
          </button>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onUnmounted, watch } from 'vue';
import { Icon } from '@iconify/vue';
import { useToast } from 'vue-toastification';
import Swal from 'sweetalert2';
import * as signalR from '@microsoft/signalr';
import CapturadorFoto from '@/components/CapturadorFoto.vue';

import {
  obtenerMembresias,
  obtenerTiposMembresia,
  crearMembresia,
  actualizarMembresia,
  eliminarMembresia,
  renovarMembresia,
  registrarRostroDispositivo,
} from '@/api/membresias';

import {
  obtenerEstadoLector,
  activarModoRegistroClienteAgente as activarModoRegistroCliente,
} from '@/api/biometrico';
import { obtenerClientes, crearCliente, formatearDocumento, formatearTelefonoVenezolano } from '@/api/clientes';
import { obtenerTasaVentaActual, obtenerTasasVenta } from '@/api/tasaVenta';
import { getCurrentApiUrl } from '@/api/index.js';

const toast = useToast();

// ==================== SIGNALR URL ====================
const API_BASE_URL = (typeof process !== 'undefined' && process.env && process.env.VUE_APP_API_BASE_URL)
  || getCurrentApiUrl();
const HUB_URL = `${API_BASE_URL}/asistenciaHub`;

// ==================== STATE ====================
const membresias = ref([]);
const tipos = ref([]);
const todosLosClientes = ref([]);
const cargando = ref(false);
const guardando = ref(false);
const showModal = ref(false);
const isEditing = ref(false);
const tasaVenta = ref(null);

const filtro = ref('');
const filtroEstado = ref('');
const filtroTipo = ref('');

const modoCliente = ref('buscar');
const buscarCliente = ref('');
const clientesEncontrados = ref([]);
const clienteSeleccionado = ref(null);
const cargandoClientes = ref(false);
const mostrarListaClientes = ref(false);
const timeoutBusqueda = ref(null);
const guardandoCliente = ref(false);

const buscarTipo = ref('');
const mostrarListaTipos = ref(false);
const tiposEncontrados = ref([]);

const mostrarCapturador = ref(false);
const fotoSocio = ref(null);
const socioParaFotoDirecto = ref(null);
const socioEditando = ref(null);

// ⭐ HUELLA
const estadoLector = ref(false);
const capturaActiva = ref(false);
const faseCaptura = ref('esperando');
const resultadoCaptura = ref(null);
const mensajeError = ref('');
const socioParaHuella = ref(null);
const huellaCapturada = ref(false);
const hubConnection = ref(null);
let timeoutEsperaId = null;

const nuevoCliente = reactive({
  tipoDocumento: '', documento: '', nombre: '', apellido: '',
  telefono: '', email: '', direccion: '', estado: 'activo'
});

const form = reactive({
  idMembresia: null,
  numero_membresia: '',
  nombre_socio: '',
  idCliente: null,
  idTipoMembresia: null,
  fecha_inicio: new Date().toISOString().slice(0, 10),
  fecha_fin: '',
  precio_usd: 0,
  precio_bs: 0,
  saldo_usd: 0,
  saldo_bs: 0,
  estado: 'activa',
  acceso_habilitado: true,
  observaciones: ''
});

const swalBase = {
  heightAuto: false,
  backdrop: 'rgba(0,0,0,0.6)',
  customClass: { popup: 'rounded-2xl', cancelButton: 'swal-cancel-btn' },
  buttonsStyling: false
};

const puedeGuardarCliente = computed(() =>
  nuevoCliente.tipoDocumento && nuevoCliente.documento?.trim() && nuevoCliente.nombre?.trim()
);

const puedeGuardar = computed(() => {
  if (isEditing.value) return form.idTipoMembresia && form.fecha_inicio;
  return clienteSeleccionado.value && form.idTipoMembresia && form.fecha_inicio;
});

const tipoSeleccionado = computed(() =>
  tipos.value.find(t => t.idTipoMembresia === form.idTipoMembresia) || null
);

const membresiasFiltradas = computed(() => {
  let arr = [...membresias.value];
  if (filtro.value.trim()) {
    const q = filtro.value.toLowerCase().trim();
    arr = arr.filter(m =>
      (m.nombre_socio || '').toLowerCase().includes(q) ||
      (m.documento_socio || '').toLowerCase().includes(q) ||
      (m.numero_membresia || '').toLowerCase().includes(q)
    );
  }
  if (filtroEstado.value) arr = arr.filter(m => m.estado === filtroEstado.value);
  if (filtroTipo.value) arr = arr.filter(m => m.idTipoMembresia === filtroTipo.value);
  return arr;
});

const totalActivas = computed(() => membresias.value.filter(m => m.estado === 'activa' && m.dias_restantes > 0).length);
const totalPorVencer = computed(() => membresias.value.filter(m => m.estado === 'activa' && m.dias_restantes > 0 && m.dias_restantes <= 7).length);
const totalVencidas = computed(() => membresias.value.filter(m => m.dias_restantes <= 0 || m.estado === 'vencida').length);

// ==================== HELPERS ====================
const getFotoUrl = (foto) => {
  if (!foto) return null;
  if (foto.startsWith('data:image')) return foto;
  if (foto.startsWith('http://') || foto.startsWith('https://')) return foto;
  const cleanPath = foto.replace(/^\/?/, '');
  if (cleanPath.startsWith('fotos_socios/') || cleanPath.startsWith('uploads/') || cleanPath.startsWith('imagenes/')) {
    return `${API_BASE_URL}/${cleanPath}`;
  }
  return `${API_BASE_URL}/imagenes/${cleanPath}`;
};

const formatBs = (valor) => {
  const num = parseFloat(valor) || 0;
  return num.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
const formatUsd = (valor) => {
  const num = parseFloat(valor) || 0;
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const iniciales = (m) => {
  const nombre = m.nombre_socio || '';
  if (!nombre) return '??';
  const p = nombre.trim().split(' ');
  if (p.length === 1) return p[0].charAt(0).toUpperCase();
  return (p[0].charAt(0) + p[p.length - 1].charAt(0)).toUpperCase();
};

const formatFecha = (f) => {
  if (!f) return '-';
  try { return new Date(f).toLocaleDateString('es-VE', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return f; }
};

const formatearTipoDocumento = (tipo) => {
  const t = { 'cedula': 'Cédula', 'rif': 'RIF', 'pasaporte': 'Pasaporte', 'identificacion_extranjera': 'Extranjera' };
  return t[tipo?.toLowerCase()] || tipo || 'Documento';
};

const normalizarMembresia = (m) => ({
  idMembresia: m.idMembresia ?? m.IdMembresia,
  numero_membresia: m.numero_membresia ?? m.NumeroMembresia ?? '',
  idCliente: m.idCliente ?? m.IdCliente,
  idUsuario: m.idUsuario ?? m.IdUsuario,
  nombre_socio: m.nombre_socio ?? m.NombreSocio ?? '',
  documento_socio: m.documento_socio ?? m.DocumentoSocio ?? '',
  idTipoMembresia: m.idTipoMembresia ?? m.IdTipoMembresia,
  nombre_tipo_membresia: m.nombre_tipo_membresia ?? m.NombreTipoMembresia ?? '',
  foto_socio: m.foto_socio ?? m.FotoSocio ?? m.foto ?? null,
  fecha_inicio: m.fecha_inicio ?? m.FechaInicio,
  fecha_fin: m.fecha_fin ?? m.FechaFin,
  precio_usd: parseFloat(m.precio_usd ?? m.PrecioUsd ?? 0),
  precio_bs: parseFloat(m.precio_bs ?? m.PrecioBs ?? 0),
  saldo_usd: parseFloat(m.saldo_usd ?? m.SaldoUsd ?? 0),
  saldo_bs: parseFloat(m.saldo_bs ?? m.SaldoBs ?? 0),
  estado: m.estado ?? m.Estado ?? 'activa',
  acceso_habilitado: m.acceso_habilitado ?? m.AccesoHabilitado ?? true,
  observaciones: m.observaciones ?? m.Observaciones ?? '',
  dias_restantes: m.dias_restantes ?? m.DiasRestantes ?? 0,
  esta_vigente: m.esta_vigente ?? m.EstaVigente ?? false
});

const normalizarTipo = (t) => ({
  idTipoMembresia: t.idTipoMembresia ?? t.IdTipoMembresia,
  codigo: t.codigo ?? t.Codigo ?? '',
  nombre: t.nombre ?? t.Nombre ?? '',
  descripcion: t.descripcion ?? t.Descripcion ?? '',
  duracion_dias: t.duracion_dias ?? t.DuracionDias ?? 30,
  precio_usd: parseFloat(t.precio_usd ?? t.PrecioUsd ?? 0),
  precio_bs: parseFloat(t.precio_bs ?? t.PrecioBs ?? 0),
  estado: t.estado ?? t.Estado ?? 'activo'
});

const cargarTasaVenta = async () => {
  try {
    const res = await obtenerTasaVentaActual();
    if (res.success && res.data) {
      tasaVenta.value = res.data;
    } else {
      const res2 = await obtenerTasasVenta('activas');
      if (res2.success && res2.data && res2.data.length > 0) {
        tasaVenta.value = res2.data[0];
      }
    }
  } catch (e) {
    console.error('❌ Error cargando tasa:', e);
  }
};

// ==================== SIGNALR ====================
const conectarSignalR = async () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');

  console.log('🔗 Conectando SignalR (MembresiasList) en:', HUB_URL);

  hubConnection.value = new signalR.HubConnectionBuilder()
    .withUrl(HUB_URL, {
      accessTokenFactory: () => token || '',
      transport: signalR.HttpTransportType.WebSocket | signalR.HttpTransportType.LongPolling
    })
    .withAutomaticReconnect()
    .build();

  hubConnection.value.on('EstadoLector', (data) => {
    console.log('📢 EstadoLector:', data);
    estadoLector.value = !!data?.conectado;
  });

  hubConnection.value.on('HuellaProcesando', (data) => {
    console.log('📢 HuellaProcesando:', data);
    if (capturaActiva.value) {
      limpiarTimeoutEspera();
      faseCaptura.value = 'procesando';
    }
  });

  hubConnection.value.on('HuellaDetectada', (data) => {
    console.log('📢 HuellaDetectada:', data);
    manejarResultadoHuella(data);
  });

  hubConnection.value.on('HuellaError', (data) => {
    console.log('📢 HuellaError:', data);
    if (capturaActiva.value) {
      limpiarTimeoutEspera();
      faseCaptura.value = 'error';
      mensajeError.value = data?.mensaje || 'Error al leer la huella';
    }
  });

  try {
    await hubConnection.value.start();
    console.log('✅ SignalR conectado (MembresiasList)');

    try {
      const res = await obtenerEstadoLector();
      if (res.success && res.data) {
        estadoLector.value = res.data.conectado || false;
      }
    } catch (_) {}
  } catch (error) {
    console.error('❌ Error SignalR (MembresiasList):', error);
  }
};

const manejarResultadoHuella = (data) => {
  if (!capturaActiva.value) return;

  limpiarTimeoutEspera();

  if (data?.exito) {
    faseCaptura.value = 'exito';
    resultadoCaptura.value = data;
    huellaCapturada.value = true;

    setTimeout(() => {
      if (faseCaptura.value === 'exito') {
        capturaActiva.value = false;
        socioParaHuella.value = null;
      }
    }, 2500);
  } else {
    faseCaptura.value = 'error';
    mensajeError.value = data?.mensaje || 'Huella no reconocida';
  }
};

const limpiarTimeoutEspera = () => {
  if (timeoutEsperaId) {
    clearTimeout(timeoutEsperaId);
    timeoutEsperaId = null;
  }
};

// ==================== CAPTURA DE HUELLA ====================
const capturarHuellaSocio = async () => {
  const cliente = clienteSeleccionado.value || socioEditando.value;
  if (!cliente?.idCliente) {
    toast.error('Primero selecciona o crea el cliente');
    return;
  }

  if (!estadoLector.value) {
    toast.error('❌ El lector FS88H no está conectado. Conéctalo desde Gestión de Huellas.');
    return;
  }

  socioParaHuella.value = {
    ...cliente,
    nombre_socio: cliente.nombre_socio || `${cliente.nombre || ''} ${cliente.apellido || ''}`.trim(),
    documento_socio: cliente.documento_socio || cliente.documento,
    foto_socio: fotoSocio.value || cliente.foto_socio
  };
  capturaActiva.value = true;
  faseCaptura.value = 'esperando';
  resultadoCaptura.value = null;
  mensajeError.value = '';

  try {
    const res = await activarModoRegistroCliente(cliente.idCliente);

    if (res.success) {
      limpiarTimeoutEspera();
      faseCaptura.value = 'exito';
      resultadoCaptura.value = {
        exito: true,
        mensaje: res.mensaje || res.data?.mensaje || 'Huella registrada correctamente'
      };
      huellaCapturada.value = true;
      toast.success('¡Huella registrada correctamente!');

      setTimeout(() => {
        if (faseCaptura.value === 'exito') {
          capturaActiva.value = false;
          socioParaHuella.value = null;
        }
      }, 2500);
      return;
    }

    faseCaptura.value = 'error';
    mensajeError.value = res.mensaje || res.error || 'No se pudo registrar la huella';
  } catch (e) {
    console.error('Error capturando huella:', e);
    faseCaptura.value = 'error';
    mensajeError.value = e.message || 'No se pudo activar el modo de registro';
  }
};

const capturarHuellaSocioExistente = async (m) => {
  if (!estadoLector.value) {
    toast.error('❌ El lector FS88H no está conectado');
    return;
  }

  if (!m.idCliente) {
    toast.error('Este socio no tiene cliente asociado');
    return;
  }

  socioParaHuella.value = {
    ...m,
    nombre_socio: m.nombre_socio,
    documento_socio: m.documento_socio,
    foto_socio: m.foto_socio
  };
  capturaActiva.value = true;
  faseCaptura.value = 'esperando';
  resultadoCaptura.value = null;
  mensajeError.value = '';

  try {
    const res = await activarModoRegistroCliente(m.idCliente);

    if (res.success) {
      limpiarTimeoutEspera();
      faseCaptura.value = 'exito';
      resultadoCaptura.value = {
        exito: true,
        mensaje: res.mensaje || res.data?.mensaje || 'Huella registrada correctamente'
      };
      huellaCapturada.value = true;
      toast.success('¡Huella registrada correctamente!');

      setTimeout(() => {
        if (faseCaptura.value === 'exito') {
          capturaActiva.value = false;
          socioParaHuella.value = null;
        }
      }, 2500);
      return;
    }

    faseCaptura.value = 'error';
    mensajeError.value = res.mensaje || res.error || 'No se pudo registrar la huella';
  } catch (e) {
    console.error('Error capturando huella:', e);
    faseCaptura.value = 'error';
    mensajeError.value = e.message || 'No se pudo activar el modo de registro';
  }
};

const cancelarCaptura = () => {
  limpiarTimeoutEspera();
  capturaActiva.value = false;
  faseCaptura.value = 'esperando';
  resultadoCaptura.value = null;
  socioParaHuella.value = null;
};

const reintentarCaptura = async () => {
  if (!socioParaHuella.value?.idCliente) return;

  faseCaptura.value = 'esperando';
  mensajeError.value = '';

  try {
    const res = await activarModoRegistroCliente(socioParaHuella.value.idCliente);
    if (res.success) {
      limpiarTimeoutEspera();
      faseCaptura.value = 'exito';
      resultadoCaptura.value = {
        exito: true,
        mensaje: res.mensaje || res.data?.mensaje || 'Huella registrada correctamente'
      };
      huellaCapturada.value = true;
      toast.success('¡Huella registrada correctamente!');

      setTimeout(() => {
        if (faseCaptura.value === 'exito') {
          capturaActiva.value = false;
          socioParaHuella.value = null;
        }
      }, 2500);
      return;
    }

    faseCaptura.value = 'error';
    mensajeError.value = res.mensaje || res.error || 'No se pudo registrar la huella';
  } catch (e) {
    faseCaptura.value = 'error';
    mensajeError.value = e.message || 'Error al reintentar';
  }
};

// ==================== CARGA DE DATOS ====================
const cargar = async () => {
  cargando.value = true;
  try {
    const [resM, resT, resC] = await Promise.all([
      obtenerMembresias(),
      obtenerTiposMembresia(),
      obtenerClientes()
    ]);

    if (resM.success) membresias.value = (resM.data || []).map(normalizarMembresia);
    if (resT.success) {
      let lista = resT.data;
      if (lista && !Array.isArray(lista) && Array.isArray(lista.data)) lista = lista.data;
      tipos.value = (Array.isArray(lista) ? lista : []).map(normalizarTipo);
    }
    if (resC.success) todosLosClientes.value = resC.data || [];

    if (tipos.value.length === 0) {
      toast.warning('No hay tipos de membresía. Crea al menos uno primero.', { timeout: 5000 });
    }
  } catch (e) {
    console.error('❌ Error cargando:', e);
    toast.error('Error al cargar datos');
  } finally {
    cargando.value = false;
  }
};

const debounceBuscarClientes = () => {
  mostrarListaClientes.value = true;
  if (timeoutBusqueda.value) clearTimeout(timeoutBusqueda.value);
  timeoutBusqueda.value = setTimeout(() => buscarClientesLocal(), 300);
};

const buscarClientesLocal = () => {
  if (!buscarCliente.value || buscarCliente.value.trim() === '') {
    clientesEncontrados.value = [];
    return;
  }
  cargandoClientes.value = true;
  const q = buscarCliente.value.toLowerCase().trim();
  setTimeout(() => {
    clientesEncontrados.value = todosLosClientes.value.filter(c => {
      const nc = `${c.nombre || ''} ${c.apellido || ''}`.toLowerCase();
      return nc.includes(q) ||
        (c.documento || '').toLowerCase().includes(q) ||
        (c.telefono || '').toLowerCase().includes(q) ||
        (c.email || '').toLowerCase().includes(q);
    }).slice(0, 10);
    cargandoClientes.value = false;
  }, 200);
};

const seleccionarCliente = (c) => {
  clienteSeleccionado.value = { ...c, idCliente: c.idCliente || c.id || c.id_cliente };
  form.idCliente = clienteSeleccionado.value.idCliente;
  buscarCliente.value = '';
  clientesEncontrados.value = [];
  mostrarListaClientes.value = false;
  toast.success(`Cliente ${clienteSeleccionado.value.nombre} seleccionado`);
};

const deseleccionarCliente = () => {
  clienteSeleccionado.value = null;
  form.idCliente = null;
  buscarCliente.value = '';
  clientesEncontrados.value = [];
};

const debounceBuscarTipos = () => {
  mostrarListaTipos.value = true;
  const q = buscarTipo.value.toLowerCase().trim();
  if (!q) {
    tiposEncontrados.value = tipos.value.slice(0, 20);
    return;
  }
  tiposEncontrados.value = tipos.value.filter(t =>
    (t.codigo || '').toLowerCase().includes(q) ||
    (t.nombre || '').toLowerCase().includes(q) ||
    (t.descripcion || '').toLowerCase().includes(q)
  ).slice(0, 20);
};

const seleccionarTipo = (t) => {
  form.idTipoMembresia = t.idTipoMembresia;
  form.precio_usd = t.precio_usd || 0;

  if (tasaVenta.value?.precio_usd_bs) {
    form.precio_bs = Number((form.precio_usd * tasaVenta.value.precio_usd_bs).toFixed(2));
  } else {
    form.precio_bs = t.precio_bs || 0;
  }

  form.saldo_usd = form.precio_usd;
  form.saldo_bs = form.precio_bs;

  if (form.fecha_inicio && t.duracion_dias) {
    const inicio = new Date(form.fecha_inicio + 'T00:00:00');
    const fin = new Date(inicio);
    fin.setDate(fin.getDate() + parseInt(t.duracion_dias));
    form.fecha_fin = fin.toISOString().slice(0, 10);
  }

  buscarTipo.value = '';
  tiposEncontrados.value = [];
  mostrarListaTipos.value = false;
  toast.success(`Plan "${t.nombre}" seleccionado`);
};

const deseleccionarTipo = () => {
  form.idTipoMembresia = null;
  form.precio_usd = 0;
  form.precio_bs = 0;
  form.fecha_fin = '';
  buscarTipo.value = '';
};

// ==================== FOTO (FSO701) ====================
const abrirCapturador = () => { mostrarCapturador.value = true; };

const capturarFotoDirecto = (m) => {
  socioParaFotoDirecto.value = m;
  mostrarCapturador.value = true;
};

const recibirFoto = async (dataUrl) => {
  if (socioParaFotoDirecto.value) {
    const m = socioParaFotoDirecto.value;
    mostrarCapturador.value = false;
    socioParaFotoDirecto.value = null;
    try {
      Swal.fire({
        ...swalBase,
        title: 'Guardando foto...',
        html: `Actualizando foto de <b>${m.nombre_socio}</b>`,
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading()
      });
      const res = await actualizarMembresia(m.idMembresia, {
        ...m,
        foto_socio: dataUrl
      });
      if (res.success) {
        registrarRostroDispositivo(m.idMembresia, dataUrl).catch(() => {});
        toast.success(`Foto guardada para ${m.nombre_socio}`);
        await cargar();
        Swal.close();
      } else {
        toast.error('No se pudo guardar la foto');
      }
    } catch (e) {
      toast.error('Error al guardar foto: ' + e.message);
    }
    return;
  }

  fotoSocio.value = dataUrl;
  mostrarCapturador.value = false;
  toast.success('Foto capturada');
};

const eliminarFoto = () => { fotoSocio.value = null; };

// ==================== CLIENTE NUEVO ====================
const guardarNuevoCliente = async () => {
  if (!puedeGuardarCliente.value) return;
  guardandoCliente.value = true;
  try {
    const payload = { ...nuevoCliente };
    if (payload.documento && payload.tipoDocumento) {
      payload.documento = formatearDocumento(payload.tipoDocumento, payload.documento);
    }
    if (payload.telefono) payload.telefono = formatearTelefonoVenezolano(payload.telefono);

    const res = await crearCliente(payload);
    if (res.success) {
      const c = res.data;
      const clienteFormateado = {
        idCliente: c.idCliente || c.id || c.id_cliente,
        nombre: c.nombre || nuevoCliente.nombre,
        apellido: c.apellido || nuevoCliente.apellido || '',
        tipoDocumento: c.tipoDocumento || nuevoCliente.tipoDocumento,
        documento: c.documento || nuevoCliente.documento,
        telefono: c.telefono || nuevoCliente.telefono,
        email: c.email || nuevoCliente.email
      };
      todosLosClientes.value.push(clienteFormateado);
      seleccionarCliente(clienteFormateado);
      Object.assign(nuevoCliente, { tipoDocumento: '', documento: '', nombre: '', apellido: '', telefono: '', email: '', direccion: '', estado: 'activo' });
      modoCliente.value = 'buscar';
      toast.success('Cliente creado y seleccionado');
    } else {
      toast.error(res.error || 'Error al crear cliente');
    }
  } catch (e) {
    console.error(e);
    toast.error('No se pudo crear el cliente');
  } finally {
    guardandoCliente.value = false;
  }
};

// ==================== MODALES ====================
const abrirModalCrearSocio = () => {
  isEditing.value = false;
  modoCliente.value = 'buscar';
  buscarCliente.value = '';
  clienteSeleccionado.value = null;
  clientesEncontrados.value = [];
  buscarTipo.value = '';
  tiposEncontrados.value = [];
  mostrarListaTipos.value = false;
  fotoSocio.value = null;
  huellaCapturada.value = false;
  Object.assign(form, {
    idMembresia: null,
    numero_membresia: '',
    nombre_socio: '',
    idCliente: null,
    idTipoMembresia: null,
    fecha_inicio: new Date().toISOString().slice(0, 10),
    fecha_fin: '',
    precio_usd: 0,
    precio_bs: 0,
    saldo_usd: 0,
    saldo_bs: 0,
    estado: 'activa',
    acceso_habilitado: true,
    observaciones: ''
  });
  showModal.value = true;
};

const openEditModal = (m) => {
  isEditing.value = true;
  huellaCapturada.value = false;
  socioEditando.value = m;
  fotoSocio.value = m.foto_socio ? getFotoUrl(m.foto_socio) : null;
  clienteSeleccionado.value = {
    idCliente: m.idCliente,
    nombre: m.nombre_socio,
    documento: m.documento_socio,
    foto_socio: m.foto_socio
  };
  Object.assign(form, {
    ...m,
    fecha_inicio: m.fecha_inicio ? m.fecha_inicio.slice(0, 10) : '',
    fecha_fin: m.fecha_fin ? m.fecha_fin.slice(0, 10) : ''
  });
  showModal.value = true;
};

// ==================== GUARDAR MEMBRESÍA ====================
const guardar = async () => {
  if (!puedeGuardar.value) {
    toast.warning('Completa los campos requeridos');
    return;
  }
  guardando.value = true;
  try {
    let res;
    if (isEditing.value) {
      res = await actualizarMembresia(form.idMembresia, {
        ...form,
        fecha_fin: form.fecha_fin || null,
        foto_socio: fotoSocio.value
      });
      if (res.success && fotoSocio.value && fotoSocio.value.startsWith('data:image')) {
        registrarRostroDispositivo(form.idMembresia, fotoSocio.value).catch(() => {});
      }
    } else {
      const payload = {
        ...form,
        idCliente: clienteSeleccionado.value.idCliente,
        fecha_fin: form.fecha_fin || null
      };
      res = await crearMembresia(payload);
    }

    if (res.success) {
      showModal.value = false;
      await cargar();

      if (!isEditing.value) {
        const nuevaMembresiaId = res.data?.idMembresia || res.data?.IdMembresia;
        if (nuevaMembresiaId && fotoSocio.value) {
          Swal.fire({
            ...swalBase,
            title: 'Registrando rostro...',
            html: 'Enviando foto al dispositivo FSO701.',
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
            customClass: { popup: 'rounded-2xl' }
          });

          const resRostro = await registrarRostroDispositivo(nuevaMembresiaId, fotoSocio.value);

          if (resRostro.success && resRostro.data?.dispositivo_confirmado) {
            Swal.fire({
              ...swalBase,
              icon: 'success',
              title: '¡Socio registrado!',
              html: `
                <div style="text-align:left;font-size:0.875rem">
                  <p>✅ Membresía creada</p>
                  <p>✅ Foto guardada</p>
                  <p>✅ Rostro registrado en el FSO701</p>
                  ${huellaCapturada.value ? '<p>✅ Huella registrada</p>' : ''}
                  <hr style="margin:12px 0;border-color:#e5e7eb">
                  <p style="color:#059669;font-weight:700">
                    🎉 El socio ya puede entrar al gym.
                  </p>
                </div>
              `,
              confirmButtonText: 'Perfecto',
              customClass: { popup: 'rounded-2xl', confirmButton: 'swal-confirm-success' }
            });
          } else {
            Swal.fire({
              ...swalBase,
              icon: 'warning',
              title: 'Membresía creada',
              html: `
                <p>La membresía y foto se guardaron.</p>
                <p style="color:#dc2626;font-size:0.875rem;margin-top:8px">
                  ⚠️ El FSO701 no confirmó: ${resRostro.data?.mensaje || resRostro.error}
                </p>
              `,
              confirmButtonText: 'OK',
              customClass: { popup: 'rounded-2xl', confirmButton: 'swal-confirm-danger' }
            });
          }
          fotoSocio.value = null;
        } else {
          Swal.fire({
            ...swalBase,
            icon: 'success',
            title: '¡Membresía creada!',
            html: huellaCapturada.value ? '<p>✅ Huella registrada para el torniquete</p>' : '',
            timer: 2500,
            showConfirmButton: false,
            customClass: { popup: 'rounded-2xl' }
          });
        }
      } else {
        Swal.fire({
          ...swalBase,
          icon: 'success',
          title: '¡Actualizado!',
          timer: 2000,
          showConfirmButton: false,
          customClass: { popup: 'rounded-2xl' }
        });
      }
    } else {
      Swal.fire({
        ...swalBase,
        icon: 'error',
        title: 'Error al guardar',
        text: res.error || 'No se pudo guardar',
        customClass: { popup: 'rounded-2xl', confirmButton: 'swal-confirm-danger' }
      });
    }
  } catch (e) {
    console.error('❌ Error guardando:', e);
    Swal.fire({
      ...swalBase,
      icon: 'error',
      title: 'Error inesperado',
      text: e.message,
      customClass: { popup: 'rounded-2xl', confirmButton: 'swal-confirm-danger' }
    });
  } finally {
    guardando.value = false;
  }
};

// ==================== OTRAS ACCIONES ====================
const sincronizarSocio = async (m) => {
  const r = await Swal.fire({
    ...swalBase,
    title: '¿Sincronizar con el dispositivo facial?',
    html: `<p>Se enviará el socio <b>"${m.nombre_socio}"</b> al FSO701.</p>`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Sí, sincronizar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
    customClass: {
      popup: 'rounded-2xl',
      confirmButton: 'swal-confirm-success',
      cancelButton: 'swal-cancel-btn'
    }
  });

  if (!r.isConfirmed) return;

  Swal.fire({
    ...swalBase,
    title: 'Sincronizando...',
    allowOutsideClick: false,
    didOpen: () => Swal.showLoading(),
    customClass: { popup: 'rounded-2xl' }
  });

  const res = await registrarRostroDispositivo(m.idMembresia, null);

  if (res.success) {
    Swal.fire({
      ...swalBase,
      icon: 'success',
      title: '¡Sincronizado!',
      text: 'El socio fue actualizado en el dispositivo',
      customClass: { popup: 'rounded-2xl', confirmButton: 'swal-confirm-success' }
    });
  } else {
    Swal.fire({
      ...swalBase,
      icon: 'error',
      title: 'Error',
      text: res.error || 'No se pudo sincronizar',
      customClass: { popup: 'rounded-2xl', confirmButton: 'swal-confirm-danger' }
    });
  }
};

const renovar = async (m) => {
  const r = await Swal.fire({
    ...swalBase,
    title: '¿Renovar membresía?',
    html: `Se renovará la membresía de <b>"${m.nombre_socio}"</b>`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Sí, renovar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
    customClass: {
      popup: 'rounded-2xl',
      confirmButton: 'swal-confirm-success',
      cancelButton: 'swal-cancel-btn'
    }
  });

  if (!r.isConfirmed) return;

  const res = await renovarMembresia(m.idMembresia);
  if (res.success) {
    Swal.fire({
      ...swalBase,
      icon: 'success',
      title: '¡Renovada!',
      timer: 2000,
      showConfirmButton: false,
      customClass: { popup: 'rounded-2xl' }
    });
    await cargar();
  } else {
    Swal.fire({
      ...swalBase,
      icon: 'error',
      title: 'Error',
      text: res.error || 'No se pudo renovar',
      customClass: { popup: 'rounded-2xl', confirmButton: 'swal-confirm-danger' }
    });
  }
};

const confirmDelete = async (m) => {
  const r = await Swal.fire({
    ...swalBase,
    title: '¿Cancelar membresía?',
    html: `Se cancelará la membresía de <b>"${m.nombre_socio}"</b>`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, cancelar',
    cancelButtonText: 'No, volver',
    reverseButtons: true,
    customClass: {
      popup: 'rounded-2xl',
      confirmButton: 'swal-confirm-danger',
      cancelButton: 'swal-cancel-btn'
    }
  });

  if (!r.isConfirmed) return;

  const res = await eliminarMembresia(m.idMembresia);
  if (res.success) {
    Swal.fire({
      ...swalBase,
      icon: 'success',
      title: 'Cancelada',
      timer: 2000,
      showConfirmButton: false,
      customClass: { popup: 'rounded-2xl' }
    });
    await cargar();
  } else {
    Swal.fire({
      ...swalBase,
      icon: 'error',
      title: 'Error',
      text: res.error || 'No se pudo cancelar',
      customClass: { popup: 'rounded-2xl', confirmButton: 'swal-confirm-danger' }
    });
  }
};

const resetFiltros = () => {
  filtro.value = '';
  filtroEstado.value = '';
  filtroTipo.value = '';
};

// ==================== WATCHERS ====================
watch(() => form.precio_usd, (nuevoUsd) => {
  if (tasaVenta.value?.precio_usd_bs) {
    const usd = parseFloat(nuevoUsd) || 0;
    form.precio_bs = Number((usd * tasaVenta.value.precio_usd_bs).toFixed(2));
    form.saldo_bs = form.precio_bs;
  }
});

watch(() => form.fecha_inicio, (nuevaFecha) => {
  if (nuevaFecha && form.idTipoMembresia) {
    const tipo = tipos.value.find(t => t.idTipoMembresia === form.idTipoMembresia);
    if (tipo) {
      const inicio = new Date(nuevaFecha + 'T00:00:00');
      const fin = new Date(inicio);
      fin.setDate(fin.getDate() + parseInt(tipo.duracion_dias));
      form.fecha_fin = fin.toISOString().slice(0, 10);
    }
  }
});

// ==================== LIFECYCLE ====================
onMounted(async () => {
  await cargarTasaVenta();
  await cargar();
  await conectarSignalR();
});

onUnmounted(() => {
  limpiarTimeoutEspera();
  if (hubConnection.value) {
    hubConnection.value.stop();
  }
});
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }
@keyframes zoomIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }
.animate-fadeIn { animation: fadeIn 0.3s ease-out; }
@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes ping {
  0% { transform: scale(1); opacity: 1; }
  75%, 100% { transform: scale(1.5); opacity: 0; }
}
.animate-ping { animation: ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite; }
.custom-scrollbar::-webkit-scrollbar { width: 4px; height: 4px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; }
</style>

<style>
.swal2-popup { border-radius: 1rem !important; padding: 1.5rem !important; }
.swal-confirm-success {
  background: linear-gradient(135deg, #059669, #10b981) !important;
  color: white !important; padding: 0.65rem 1.5rem !important;
  border-radius: 0.75rem !important; font-weight: 700 !important;
  border: none !important; cursor: pointer !important;
}
.swal-confirm-danger {
  background: linear-gradient(135deg, #dc2626, #e11d48) !important;
  color: white !important; padding: 0.65rem 1.5rem !important;
  border-radius: 0.75rem !important; font-weight: 700 !important;
  border: none !important; cursor: pointer !important;
}
.swal-cancel-btn {
  background: #f3f4f6 !important; color: #374151 !important;
  padding: 0.65rem 1.5rem !important; border-radius: 0.75rem !important;
  font-weight: 700 !important; border: 1px solid #e5e7eb !important;
  cursor: pointer !important;
}
.dark .swal2-popup { background: #1f2937 !important; color: #f3f4f6 !important; }
.dark .swal2-title { color: #f3f4f6 !important; }
.dark .swal-cancel-btn { background: #374151 !important; color: #e5e7eb !important; }
</style>